import { createStore, combineReducers } from 'redux';
import { createReducer, createSelector, createActor, createHydrator } from '@sharingapples/redux';
import guidesStoreDataStructure from '@common/data-structure/guides';
import { devToolsEnhancer } from 'redux-devtools-extension';
import isPast from 'date-fns/is_past';

const STORAGE_KEY = 'skey';

const hydrator = createHydrator(guidesStoreDataStructure, (state) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
});

const structureReducer = combineReducers(createReducer(guidesStoreDataStructure));
const reducer = hydrator.enhanceReducer(structureReducer);

const store = createStore(
  reducer,
  devToolsEnhancer(),
);

export const useSelector = createSelector(guidesStoreDataStructure, store)
export const reduxDB = createActor(guidesStoreDataStructure, store.dispatch);


// HYDRATE STORE IF DATA EXISTS IN LOCAL STORAGE
const data = localStorage.getItem(STORAGE_KEY);
if (data) {
  hydrator.hydrate(store, JSON.parse(data));
};

// CLEAR GUIDE SEARCH FILTERS ON RELOAD
reduxDB.guideSearchFilters.update({ baseCity: '', languages: [], experience: null });
reduxDB.guideSortKeys.update({ order: -1, sortFunction: 'sortByAverageRating' });

// CLEAR START, END DATES, NUM OF DAYS IF START DAY IS IN PAST
const { guideSearchQuery } = store.getState();
if (guideSearchQuery) {
  const { startDate } = guideSearchQuery;
  if(isPast(new Date(), startDate)) {
    reduxDB.guideSearchQuery.update({
      startDate: null,
      endDate: null,
      numberOfDays: null,
    });
  }
};
